import styles from './IncompleteApplication.module.css';
import { AnchorButton, Icon } from '@blueprintjs/core';
import { loan_application } from '@axo/shared/data-access/types';
import { useGetApplicationFormHref } from '../../../utils/goToApplicationForm.ts';

export const IncompleteApplication = ({
  application,
}: {
  application: loan_application.LoanApplication;
}) => {
  const formHref = useGetApplicationFormHref(
    application.MarketCountry,
    application.MagicToken,
    application.Product,
    application.Meta?.Brand,
  );

  return (
    <div className={styles.container}>
      <Icon icon={'disable'} size={40} className={styles.icon} />
      <p>
        Finish the application form to start receiving offers from the banks
      </p>
      <AnchorButton
        intent={'primary'}
        rightIcon={'share'}
        target="_blank"
        href={formHref}
        rel="noopener noreferrer"
        disabled={!formHref}
      >
        Go to application form
      </AnchorButton>
    </div>
  );
};
